import { INFO, SET_DATA, UPDATE_USER_INFO } from './types'

export const setUserDataAction = (props: any) => ({
  type: SET_DATA,
  payload: props
})

export const updateUserInfoAction = (props: any) => ({
  type: UPDATE_USER_INFO,
  payload: props
})

export const getUserInfoAction = () => ({
  type: INFO
})
